export const translations = {
  // Navigation
  nav: {
    about: { zh: '關於我們', en: 'About' },
    services: { zh: '服務項目', en: 'Services' },
    news: { zh: '最新消息', en: 'News' },
    careers: { zh: '加入誠揚', en: 'Careers' },
    contact: { zh: '聯絡我們', en: 'Contact' }
  },

  // Header
  header: {
    companyName: { 
      zh: '誠揚聯合會計師事務所 台北分所', 
      en: 'Cheng Yang & Co., CPAs Taipei Division'
    }
  },

  // Home Page
  home: {
    heroTitle: { 
      zh: '誠信為本．專業為榮', 
      en: 'Built on Integrity. Driven by Excellence.'
    },
    heroSubtitle: { 
      zh: '致力於為客戶提供廣泛的會計、稅務、審計、簽證服務。無論您是小型初創企業、中小型企業，還是個人客戶，我們都能夠量身定制解決方案，以滿足您獨特的需求。', 
      en: 'A Trusted Partner for Tax, Accounting, and Regulatory Compliance in Taiwan.\nSupporting international businesses at every stage of their Taiwan operations.'
    },
    heroSubtitleMobile: {
      zh: '提供會計、稅務、審計與簽證等專業服務。無論是企業或個人客戶，我們皆可依需求提供合適支援。',
      en: 'A Trusted Partner for Tax, Accounting, and Regulatory Compliance in Taiwan.'
    },
    businessHours: { 
      zh: '週一至週五 09:00–18:00', 
      en: 'Mon - Fri 09:00–18:00' 
    },
    ctaAbout: { zh: '了解我們', en: 'About Us' },
    ctaServices: { zh: '服務項目', en: 'Services' },
    ctaCareers: { zh: '查看職缺', en: 'View Jobs' },
    ctaContact: { zh: '聯絡我們', en: 'Contact Us' }
  },

  // Services Page
  services: {
    pageTitle: { zh: '服務項目', en: 'Our Services' },
    pageSubtitle: { 
      zh: '我們提供全面的會計、稅務和審計服務，為您的企業量身打造最佳解決方案。', 
      en: 'We provide comprehensive accounting, tax, audit, and compliance services designed to support your business with clarity and confidence.' 
    },
    pageSubtitleMobile: {
      zh: '我們提供會計、稅務與審計等專業服務，依需求提供合適支援。',
      en: 'We provide accounting, tax, audit, and compliance services to support your business needs.'
    },
    ctaTitle: { zh: '有其他需求嗎?', en: 'Have Additional Requirements?' },
    ctaText: { 
      zh: '歡迎與我們取的聯繫讓誠揚更好的協助您的需求，您可以往下一頁與我們取得聯繫獲取相關服務細項或是查看最新消息了解最新法規與相關規定。', 
      en: 'Contact us to discuss how we can better support your specific needs. You may also visit our Contact page or review the Latest News section for recent regulatory updates.' 
    },
    ctaContact: { zh: '聯絡我們', en: 'Contact Us' },
    ctaNews: { zh: '查看最新消息', en: 'View Latest News' },
    // Service Categories
    businessReg: { zh: '工商登記', en: 'Corporate Registration' },
    accounting: { zh: '會計服務', en: 'Accounting Services' },
    offshore: { zh: '境外公司', en: 'Offshore & Foreign Entity Services' },
    payroll: { zh: '薪資管理', en: 'Payroll Administration' },
    audit: { zh: '審計服務', en: 'Audit & Assurance' },
    taxFiling: { zh: '稅務申報', en: 'Tax Filing' },
    // Corporate Registration Items
    companySetup: { zh: '公司設立登記', en: 'Company incorporation' },
    branchSetup: { zh: '分公司設立', en: 'Branch setup' },
    specialPermit: { zh: '各項特許申請', en: 'License/permit applications' },
    directorChange: { zh: '董監事變更', en: 'Director/Supervisor changes' },
    businessChange: { zh: '營利事項變更', en: 'Business registration changes' },
    otherChange: { zh: '其他變更登記', en: 'Other amendments' },
    // Accounting Services Items
    financialStatement: { zh: '財務報表試算', en: 'Financial statements / trial balance' },
    taxConsulting: { zh: '稅務諮詢服務', en: 'Tax advisory' },
    bookkeeping: { zh: '帳務輔導服務', en: 'Bookkeeping support' },
    monthlyClose: { zh: '財務帳月結服務', en: 'Monthly closing' },
    otherAccounting: { zh: '其他會計服務', en: 'Other accounting support' },
    // Offshore & Foreign Entity Items
    offshoreInvest: { zh: '境外公司投資', en: 'Offshore investment support' },
    workPermit: { zh: '在台工作證申請', en: 'Taiwan work permit support' },
    offshoreBranch: { zh: '分公司設立', en: 'Branch office setup' },
    repOffice: { zh: '辦事處設立', en: 'Representative office setup' },
    otherCompany: { zh: '其他公司服務', en: 'Other corporate support' },
    // Payroll Administration Items
    payrollCalc: { zh: '薪資計算服務', en: 'Payroll processing' },
    payrollTransfer: { zh: '處理薪資轉帳事宜', en: 'Payroll bank transfers' },
    hrInsurance: { zh: '人事資兼勞健保', en: 'Labor/Health Insurance administration' },
    approvalSystem: { zh: '表單簽核系統', en: 'Approval workflow support' },
    // Audit & Assurance Items
    auditCert: { zh: '審計簽證服務', en: 'Audit & attestation' },
    financialCert: { zh: '財務簽證服務', en: 'Financial statement attestation' },
    taxCert: { zh: '稅務簽證服務', en: 'Tax attestation' },
    otherAudit: { zh: '其他審計業務', en: 'Other assurance services' },
    // Tax Filing Items
    corpTax: { zh: '營所稅結算申報', en: 'Corporate income tax filing' },
    withholdingTax: { zh: '扣繳(暫繳)申報', en: 'Withholding / provisional filings' },
    personalTax: { zh: '綜所稅申報', en: 'Individual income tax filing' },
    estateTax: { zh: '遺產稅申報', en: 'Estate tax filing' },
    otherTax: { zh: '其他申報服務', en: 'Other tax filings' }
  },

  // News Page
  news: {
    pageTitle: { zh: '最新消息', en: 'News & Resources' },
    pageSubtitle: { 
      zh: '提供稅務、會計及相關法規資源連結，方便您快速查閱各政府機關網站。', 
      en: 'Access official tax, accounting, and regulatory resources through the links below.' 
    },
    clickToVisit: { zh: '前往網站 →', en: 'Visit site →' },
    additionalInfo: { 
      zh: '如果您需要更多關於最新稅務、會計的諮詢，歡迎與我們聯繫詳談。我們將為您提供專業的建議。', 
      en: 'For further guidance on recent tax and accounting updates, please contact us. We are committed to providing clear and reliable professional advice.' 
    },
    // News Links
    taxPortal: { zh: '財政部稅務入口', en: 'Ministry of Finance Tax Portal' },
    taxPortalDesc: { zh: '查詢最新稅務相關法規與申報資訊', en: 'Latest tax regulations and filing information' },
    cpaUnion: { zh: '會計師公會聯合網', en: 'CPA Associations Network' },
    cpaUnionDesc: { zh: '中華民國會計師公會全國聯合會官方網站', en: 'Official website of ROC CPA Associations' },
    nhiPortal: { zh: '衛生福利部中央健康保險署', en: 'National Health Insurance Administration' },
    nhiPortalDesc: { zh: '健保相關規定與服務資訊', en: 'Health insurance regulations and services' },
    laborPortal: { zh: '勞動部勞工保險局全球資訊網', en: 'Bureau of Labor Insurance' },
    laborPortalDesc: { zh: '勞保相關規定與服務資訊', en: 'Labor insurance regulations and services' },
    taipeiLabor: { zh: '臺北市政府勞動局入口', en: 'Taipei City Labor Department' },
    taipeiLaborDesc: { zh: '台北市勞動相關法規與服務', en: 'Taipei labor regulations and services' },
    commercePortal: { zh: '全國商工行政服務入口', en: 'Commerce Administration Portal' },
    commercePortalDesc: { zh: '公司登記與商工相關服務', en: 'Company registration and commerce services' }
  },

  // Contact Page
  contact: {
    pageTitle: { zh: '聯絡我們', en: 'Contact Us' },
    pageSubtitle: { 
      zh: '我們期待與您聯繫，為您提供專業的會計和稅務服務。', 
      en: 'We look forward to working with you and providing guidance in accounting, tax, audit, and compliance matters.' 
    },
    contactPerson: { zh: '聯絡窗口', en: 'Contact Information' },
    businessHours: { zh: '營業時間', en: 'Business Hours' },
    hours: { zh: '週一至週五 09:00–18:00', en: 'Mon - Fri 09:00–18:00' },
    additionalInfo: { 
      zh: '如有任何會計、稅務或審計相關需求，歡迎透過以上方式與我們聯絡，我們將盡快回覆。', 
      en: 'For any accounting, tax, or audit inquiries, please contact us. We will respond as soon as possible.' 
    }
  },

  // About Page
  about: {
    pageTitle: { zh: '關於我們', en: 'About Us' },
    pageSubtitle1: { 
      zh: '我們是一家深耕在地超過20年的會計師事務所，以專業與誠信為基石，為中小企業、初創企業、企業家及個人客戶提供全面的會計、稅務與審計服務，協助客戶穩健經營與長遠發展。', 
      en: 'Cheng Yang & Co., CPAs Taipei Division is a Taiwan-based CPA firm with more than 20 years of local professional experience. We provide accounting, tax, audit, and regulatory compliance services tailored to Taiwan\'s business environment.' 
    },
    pageSubtitle2: { 
      zh: '', 
      en: 'We support local SMEs, entrepreneurs, and foreign companies operating in Taiwan with practical guidance on company formation, tax compliance, and ongoing financial management. Our team values clear communication, dependable service, and responsible professional support.' 
    },
    missionTitle: { zh: '我們的使命', en: 'Our Mission' },
    missionText: { 
      zh: '溝通建立信任，用負責守護每一份託付，是我們服務每一位客戶的核心原則。', 
      en: 'We deliver clear, responsible, and dependable professional support.' 
    },
    missionCard1: { 
      zh: '無論您是小型初創企業、中小型企業，還是個人客戶，我們都能夠量身定制解決方案，以滿足您獨特的需求。', 
      en: 'We provide practical solutions tailored to each client\'s business needs.' 
    },
    missionCard2: { 
      zh: '我們不僅提供專業建議，更重視充分溝通與需求釐清，協助客戶在各項財務與稅務事項上做出清楚、穩健的決策。', 
      en: 'We work closely with clients to support confident decision-making.' 
    },
    cultureTitle: { zh: '核心文化', en: 'Core Values' },
    culturePolite: { zh: '禮貌', en: 'Professionalism' },
    cultureResponsibility: { zh: '責任', en: 'Accountability' },
    cultureSelfManagement: { zh: '自主管理', en: 'Ownership' },
    // Core Values (Chinese only)
    coreValuesTitle: { zh: '核心價值', en: '' },
    coreValuesSubtitle: { zh: '我們的五大核心價值引領著我們的每一項業務', en: '' },
    valueIntegrity: { zh: '誠信', en: '' },
    valueIntegrityDesc: { zh: '誠信是我們的基石。我們以自我要求為先，秉持誠實與正直的態度與客戶往來，對重要資訊清楚說明，讓每一項建議與成果都值得信賴。', en: '' },
    valueProfessional: { zh: '專業', en: '' },
    valueProfessionalDesc: { zh: '我們以準則與實務為依據，重視細節與流程品質，提供可執行、可追溯的建議與成果。面對不同產業與需求，我們以理解業務與風險為前提，協助客戶做出合適決策。', en: '' },
    valueGrowth: { zh: '成長', en: '' },
    valueGrowthDesc: { zh: '我們重視團隊的持續學習與能力提升，透過制度化培訓與經驗傳承，維持穩定的服務品質。面對法規與環境變化，我們持續更新專業知識，確保服務與時俱進。', en: '' },
    valueResponsibility: { zh: '責任', en: '' },
    valueResponsibilityDesc: { zh: '我們理解每一份委託都關乎客戶的營運與風險控管，因此以負責的態度審核與處理每個細節。從資料確認到申報與簽證，我們重視準確性與時效，確保交付成果符合規範與需求。', en: '' },
    valueGratitude: { zh: '感恩', en: '' },
    valueGratitudeDesc: { zh: '我們珍惜每一次合作與信任，並以踏實、穩定的服務回應客戶的期待。也感謝客戶長期的支持，讓我們得以持續精進，成為值得信賴的專業夥伴。', en: '' }
  },

  // Careers Page
  careers: {
    pageTitle: { zh: '加入誠揚', en: 'Ready for a Career?' },
    pageSubtitle: { 
      zh: '成為我們團隊的一員，與我們一起成長，創造卓越。', 
      en: 'Cheng Yang CPA values innovation, collaboration, and integrity. We foster a culture of teamwork and mutual respect, creating an environment where your contributions are not only acknowledged but also celebrated.' 
    },
    pageSubtitleMobile: {
      zh: '歡迎加入誠揚，在實務中累積專業能力，與團隊穩定成長。',
      en: 'Join our team and grow your career in a supportive, professional environment.'
    },
    jobOpenings: { zh: '職缺資訊', en: 'Job Openings' },
    jobOpeningsSubtitle: { zh: '我們目前正在招募以下職位', en: 'We are currently recruiting for the following positions' },
    howToApply: { zh: '應徵方式', en: 'How to Apply' },
    applyText: { 
      zh: '歡迎來信或透過', 
      en: 'Please email us or apply via ' 
    },
    jobPlatform: { zh: '第三方徵才平台', en: 'job platform' },
    applyTextEnd: { zh: '與我們聯繫。', en: ' to contact us.' },
    // Job Details
    juniorTitle: { zh: '初級查(記)帳員', en: 'Junior Accountant / Bookkeeper' },
    seniorTitle: { zh: '資深查(記)帳員', en: 'Senior Accountant / Bookkeeper' },
    education: { zh: '學歷要求：', en: 'Education' },
    educationReq: { 
      zh: '專科、大學、碩士（會計學相關科系）', 
      en: 'College / University / Master\'s degree in Accounting or a related field' 
    },
    experience: { zh: '工作經驗：', en: 'Experience' },
    expNone: { zh: '無', en: 'No prior experience required (entry-level)' },
    expTwoYears: { zh: '2年以上', en: '2+ years of relevant accounting/bookkeeping experience' },
    languageReq: { zh: '語言要求：', en: 'Language Requirement' },
    languageReqText: { 
      zh: '中文（普通話）', 
      en: 'Chinese (Mandarin) is required, as Mandarin is the primary working language (able to communicate effectively in day-to-day work)' 
    },
    responsibilities: { zh: '職務說明：', en: 'Key Responsibilities' },
    preferred: { zh: '加分條件：', en: 'Preferred (Not Required)' },
    preferredText: { 
      zh: '其他語言具基本工作溝通能力者佳，非必要條件。', 
      en: 'Additional language ability for routine work communication is a plus, but not required.' 
    },
    // Responsibilities
    resp1: { zh: '審查財務會計收支文件及憑證', en: 'Review accounting documents and supporting vouchers for accuracy and completeness' },
    resp2: { zh: '紀錄及彙整交易產生之原始憑證並製作傳票', en: 'Organize and compile source documents and prepare journal entries' },
    resp3: { zh: '其他財務分析資料（包含各科目餘額明細表）', en: 'Prepare financial analysis and account balance detail schedules (including account balance detail reports)' },
    resp3Junior: { zh: '其他財務分析資料（包含各科目餘額明細表）', en: 'Prepare basic financial analysis and account balance detail schedules (including account balance detail reports)' },
    resp4: { zh: '申報營業稅、各類所得申報及所得稅', en: 'Handle tax compliance filings, including business tax (VAT), various income/withholding reports, and income tax filings' },
    resp4Junior: { zh: '申報營業稅、各類所得申報及所得稅', en: 'Assist with tax compliance filings, including business tax (VAT), various income/withholding reports, and income tax filings' },
    resp5: { zh: '熟悉「文中」查記帳軟體', en: 'Proficient with Wen-Zhong (文中) accounting software' },
    // Chinese only sections
    recruitPhilosophy: { zh: '招募理念', en: '' },
    recruitPhilosophyDesc: { zh: '我們重視紮實的基本功與工作品質，也重視良好的溝通與團隊合作。', en: '' },
    recruitBullet1: { zh: '前輩帶教：在實務工作中一步步學習，建立會計與稅務能力', en: '' },
    recruitBullet2: { zh: '團隊合作：重視團隊默契與協作，讓每項工作都能穩定推進', en: '' },
    recruitBullet3: { zh: '友善環境：穩定的工作氛圍與完善福利', en: '' },
    testimonials: { zh: '學長姊分享', en: '' },
    testimonialsSubtitle: { zh: '聽聽我們團隊成員的真實感受', en: '' },
    testimonial1: { zh: '在團隊中，展現自我、進行實驗、承擔責任、面對挫折、吸取經驗、力求進步，並透過團體凝聚力，提升自我肯定及相互信任的價值。', en: '' },
    testimonial2: { zh: '公司提供不同的工作項目和發展機會，能夠學習新知及充分應用專業知識。在這繁忙的職場中，提高效率、善用時間，可實現工作與生活間的平衡。', en: '' },
    testimonial3: { zh: '同仁重視合作與協同作業，每位成員都願意分享知識與經驗，這讓我感到非常溫暖與受歡迎。這樣的環境使我更勇於提出問題，學習新知識，並且充滿信心地面對挑戰。', en: '' }
  },

  // Footer
  footer: {
    companyName: { zh: '誠揚聯合會計師事務所 台北分所', en: 'Cheng Yang & Co., CPAs Taipei Division' },
    companyNameEn: { zh: 'Cheng Yang & Co., CPAs Taipei Division', en: 'Cheng Yang & Co., CPAs Taipei Division' },
    quickLinks: { zh: '快速連結', en: 'Quick Links' },
    contactInfo: { zh: '聯絡資訊', en: 'Contact Info' },
    businessHours: { zh: '營業時間', en: 'Business Hours' },
    copyright: { 
      zh: '誠揚聯合會計師事務所 台北分所 All Rights Reserved.', 
      en: 'Cheng Yang & Co., CPAs Taipei Division. All Rights Reserved.' 
    }
  }
};

export const getTranslation = (key, lang) => {
  const keys = key.split('.');
  let result = translations;
  for (const k of keys) {
    result = result?.[k];
  }
  return result?.[lang] || result?.zh || key;
};
